import { render, staticRenderFns } from "./CartItem.vue?vue&type=template&id=8785d6ce&scoped=true"
import script from "./CartItem.vue?vue&type=script&lang=ts"
export * from "./CartItem.vue?vue&type=script&lang=ts"
import style0 from "./CartItem.vue?vue&type=style&index=0&id=8785d6ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8785d6ce",
  null
  
)

export default component.exports